import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['en', 'zh-TW', 'ja', 'fr'],
  defaultLocale: 'en',
  localePrefix: 'as-needed',
  localeDetection: false,
  localeCookie: {
    name: 'NEXT_LOCALE',
    sameSite: 'lax' as const,
    maxAge: 31536000, // 1 year – match the value the LanguageSwitcher sets
    path: '/',        // explicit root path prevents duplicate cookies with different paths
    // ZAP 10011 / ISO A.8.24: never send the preference cookie over plain HTTP in prod.
    // (Dev runs on http://localhost, where a Secure cookie would be dropped.)
    secure: process.env.NODE_ENV === 'production',
  },
});
